import { h, Fragment } from 'preact';
import Image from 'utils/image';
import { formatMoney } from 'utils/storefront/format-resource';
import { useState, useMemo, useEffect } from 'preact/hooks';
import { withCartContext } from './cart-context';
import extractAndFormat from '../utils/extract-and-format';

const CartUpsells = (props) => {
  const { searchSpringUpsellSettings, upsell } = props.data;
  const { cart } = props;
  const cartItems = props.cart?.state?.items;
  const { siteId } = searchSpringUpsellSettings;
  const [searchSpringUpsell, setSearchSpringUpsell] = useState(null);
  const tags = 'customers-also-viewed';
  const [enable, setEnable] = useState(false);

  useEffect(() => {
    setEnable(cart.state.total_price >= upsell.minPrice && cart?.state?.total_price > 0);
  }, [cart]);

  if (searchSpringUpsellSettings.show && !!siteId) {
    useEffect(() => {
      const options = {
        method: 'GET',
        headers: { accept: 'application/json' },
      };
      const productIds = props.cart?.state?.items
        ?.map((item) => item.product_id)
        .join(',');

      fetch(
        // eslint-disable-next-line max-len
        `https://${siteId}.a.searchspring.io/boost/${siteId}/recommend?tags=${tags}&cart=${productIds}`,
        options,
      )
        .then((response) => response.json())
        .then((response) => {
          const randomIndex = Math.floor(
            Math.random() * response[0].results.length,
          );

          setSearchSpringUpsell(response[0].results[randomIndex]);
        })
        .catch((err) => console.error(err));
    }, []);
  }

  const {
    upsellVariantId,
    upsellProductTitle,
    upsellProductImage,
    upsellProductPrice,
    upsellProductDescription,
  } = useMemo(() => {
    if (searchSpringUpsell && searchSpringUpsellSettings.show && !!siteId) {
      return {
        upsellVariantId: JSON.parse(searchSpringUpsell.attributes?.variants)[0]
          .id,
        upsellProductTitle: searchSpringUpsell.attributes.title,
        upsellProductImage: searchSpringUpsell.mappings.core.imageUrl,
        upsellProductPrice: searchSpringUpsell.mappings.core.price,
        upsellProductDescription: searchSpringUpsell.mappings.core.description,
      };
    }
    return {
      upsellVariantId: upsell.productVariantId,
      upsellProductTitle: upsell.productTitle,
      upsellProductImage: upsell.productImage,
      upsellProductPrice: upsell.productPrice,
      upsellProductDescription: upsell.productDescription,
    };
  }, [upsell, searchSpringUpsell]);

  const handleAddToCart = (e) => {
    e.preventDefault();
    const addToCartEvent = new CustomEvent('cart:add', {
      detail: {
        payload: {
          merchandiseId: `${upsellVariantId}`,
          quantity: 1,
        },
      },
    });
    document.dispatchEvent(addToCartEvent);
  };

  const showUpsell =
    !cartItems || !cartItems.some((item) => item.id === upsellVariantId);
  return (
    <>
      {upsellVariantId && (
        <div className="bg-supergoop-yellow px-5 pt-4 pb-5 text-grey-2A">
          <div className="mb-[6px]  font-light leading-5">{upsell.title}</div>
          <div className="bg-white flex p-[10px] items-center">
            <div className="flex basis-[58px] max-w-[58px] lg:basis-[65px] lg:max-w-[65px] ">
              <Image
                src={upsellProductImage}
                classes="block object-contain w-full h-auto"
                alt={upsellProductTitle}
              />
            </div>
            <div className="pl-[10px] text-[12px]">
              <div className="body-sm text-sm mb-[2px]">{upsellProductTitle}</div>
              <div className=" text-grey-5C">{upsellProductDescription}</div>
              <button
                className="cta-medium no-underline text-[10px] mt-[6px] tracking-[1px]"
                onClick={(e) => {
                  handleAddToCart(e);
                }}
              >
                {window.TMW.Strings.product.addToCart} - {extractAndFormat(
                  formatMoney({ amount: upsellProductPrice }, true),
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withCartContext(CartUpsells);
